import React from 'react';
import logo from '../../assets/logo.svg';
import { ASPBackground, ASPLogo, ASPShadowBox } from './applicationStatusPageComponents';
import { Text, Title } from '../../lib/typography/Typography/Typography';

export const ApplicationStatusUpgradingPage: React.FC = () => {
  return (
    <ASPBackground>
      <ASPShadowBox>
        <ASPLogo src={logo} />
        <Title $size="large">Application is being upgraded.</Title>
        <Text>Sorry for the inconvenience, please try again later.</Text>
      </ASPShadowBox>
    </ASPBackground>
  );
};
